export const data = [
    {
        type: ['Бронирование', 'в сутки'],
        beforePrice: 5600,
        afterPrice: 7800,
    },
    {
        type: ['Стоимость', 'за м²'],
        beforePrice: 42000,
        afterPrice: 47000,
    },
    {
        type: ['Бронирование', 'в сутки'],
        beforePrice: 4700,
        afterPrice: 6200,
    },
    {
        type: ['Стоимость', 'за м²'],
        beforePrice: 68000,
        afterPrice: 76000,
    },
] as IData[]

interface IData {
    type: ['Бронирование', 'в сутки'] | ['Стоимость', 'за м²'],
    beforePrice: number,
    afterPrice: number,
}